import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  root: {
    background: theme.palette.common.white,
    boxShadow: "0px 1px 0px rgba(0, 0, 0, 0.15)",
    "@media print": {
      display: "none",
    },
  },
  avatar: {
    display: "flex",
    alignItems: "center",
    margin: "auto 0 auto auto",
  },
  barContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: 1078,
    height: theme.spacing(8),
    padding: theme.spacing(0, 3),
    margin: "0 auto",
  },
  organiserLogo: {
    width: 52,
    height: 52,
    border: `1px solid ${grey[400]}`,
    borderRadius: theme.spacing(1),
  },
  show: {
    display: "flex",
    alignItems: "center",
    margin: "auto auto auto 0",
  },
  showLogo: {
    width: 52,
    height: 52,
    border: `1px solid ${grey[400]}`,
    borderRadius: theme.spacing(1),
  },
  text: {
    padding: theme.spacing(2),
  },
}));
